import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrows-bdown",
  "use": "icon-arrows-bdown-usage",
  "viewBox": "0 0 18 29",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 29\" id=\"icon-arrows-bdown\">\r\n  <defs>\r\n    <style>\r\n      #icon-arrows-bdown .cls-1 {\r\n        fill: #439aff;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-arrows-bdown_形状_6\" data-name=\"形状 6\" class=\"cls-1\" d=\"M1290.56,705v16.538H1284l8.99,12.476,9-12.476h-6.56V705h-4.87Z\" transform=\"translate(-1284 -705)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrows-bdown.svg
// module id = tpOz
// module chunks = 127